import repository from '@/repositories/Repository'

const resource = '/api/omatome'

/**
 * おまとめリポジトリ
 */
export default {
  /**
   *
   * @param {Array<String>} omatomeCodes おまとめコード
   */
  get(omatomeCodes) {
    return repository.giggle
      .get(`${resource}?omatomeCodes=${omatomeCodes.join(',')}`)
      .then(r => r.data)
  },
}
